import {
    CREATE_USER_PRODUCT_MEMBERSHIP_POOL,
    CREATE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE,
    CREATE_USER_PRODUCT_MEMBERSHIP_POOL_SUCCESS,
} from 'store/actions/types';

export const createUserProductMembershipPool = (payload) => {
    return {
        type: CREATE_USER_PRODUCT_MEMBERSHIP_POOL,
        payload,
    };
};

export const createUserProductMembershipPoolFailure = (payload) => {
    return {
        type: CREATE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE,
        payload,
    };
};

export const createUserProductMembershipPoolSuccess = (payload) => {
    return {
        type: CREATE_USER_PRODUCT_MEMBERSHIP_POOL_SUCCESS,
        payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/users/product-membership-pool/createUserProductMembershipPool.js